import React from 'react';
import { NavigationItem } from '../../../types/navigationItem';
import { VLink } from '../../other/vLink';
import Link from 'gatsby-link';

export interface MobileNavsProps {
  navigation: NavigationItem[];
}

export const MobileNavs: React.FC<MobileNavsProps> = ({ navigation }) => {

return (
    <>
      {navigation && navigation.map((navigationItem, index) => {
        return (
          <div key={index} className="px-10 pt-6 mb-6 border-t border-stone">
            <VLink className="block ml-8 text-xl font-bold cursor-pointer" to={navigationItem.titleLink}>{navigationItem.title}</VLink>

            {navigationItem.sections && navigationItem.sections.map((section, sectionIndex) => {
              return (
                <div key={sectionIndex}>
                {section.sectionTitle &&
                  <p className="mt-4 ml-8 text-lg font-bold">{section.sectionTitle}</p>
                }

                {section.sectionLinks && section.sectionLinks.map((sectionLink, sectionLinkIndex) => {

                  if (sectionLink.sectionLinkType === 'Feature Link') {
                    return (
                      <div key={sectionLinkIndex} className="mt-4 ml-8">
                        <p className="font-bold uppercase">{sectionLink.sectionLinkTitle}</p>
                        <Link className="block underline uppercase"  key={sectionLink.key} to={sectionLink.sectionLinkSlug}>

                          <div
                            className="w-full h-32 mb-2 bg-center bg-cover sm:w-1/2 md:w-1/3"
                            style={{
                              backgroundImage: `url(${sectionLink.sectionLinkFeatureImage.url})`,
                              }}
                          />
                        </Link>
                        <Link className="block underline uppercase"  key={sectionLink.key} to={sectionLink.sectionLinkSlug}>
                          {sectionLink.sectionLinkCtaLinkText}
                        </Link>
                      </div>
                    );
                  }

                  return (
                    <VLink className="block ml-8 text-lg cursor-pointer" to={sectionLink.sectionLinkSlug}>{sectionLink.sectionLinkTitle}</VLink>
                  );
                })}

                </div>
              );
            })}
          </div>
        );

      })}

    </>
  );
};
